import { PromptForm } from 'lauria/components/prompts/PromptForm'
import { PromptNavigation } from 'lauria/components/prompts/PromptNavigation'
import { PromptConversationProvider } from 'lauria/contexts/PromptConversationContext'
import { promptLayout } from 'lauria/store/slices/promptLayout'
import { useSelector } from 'react-redux'

export const PromptEdition = () => {
  const { application } = useSelector(promptLayout)

  if (!application) {
    return null
  }

  return (
    <div className="prompt-page">
      <PromptNavigation application={application} />

      <div className="prompt-content">
        <PromptConversationProvider>
          <PromptForm application={application} />
        </PromptConversationProvider>
      </div>
    </div>
  )
}
